<script>
import GenericCrud from "@forms/GenericCrud.vue";
import api from "@services/api";
import DateRangePicker from "vue2-daterange-picker";
import dateRangePickerConfig from "@configs/dateRangePickerConfig";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

export default {
  extends: GenericCrud,
  components: {
    DateRangePicker
  },
  props: {
    table: {
      type: String,
      default: "AgendaRegra"
    },
    closeModalAgendaRegra: {
      type: Function
    },
    agendaId: {
      type: Number,
      default: 0
    },
    select: {
      type: Object,
      default: null
    }
  },
  computed: {
    ProjetosFormatados() {
      return this.projetoList.map(p => {
        p.descricaoSelect =
          p.descricao + " " + p.cliente + " " + p.dataInicio + "-" + p.dataFim;
        return p;
      });
    },
    alert() {
      return this.$store.state.alert;
    }
  },
  data: () => ({
    hasRecorrencia: false,
    hasExcecoes: false,
    selected: 0,
    projetoList: [],
    consultorList: {},
    expedienteLocalList: {},
    customRanges: dateRangePickerConfig.customRanges,
    maxDate: dateRangePickerConfig.maxDate(),
    localeData: dateRangePickerConfig.localeData,
    dateRange: {
      startDate: new Date(),
      endDate: new Date()
    },
    recorrencia: ""
  }),
  watch: {
    item: function(val) {
      if (val.agendaRegraExcecao && val.agendaRegraExcecao.length > 0) {
        this.hasExcecoes = true;
      } else {
        this.hasExcecoes = false;
      }
      this.hasRecorrencia = val.recorrencia == "" ? false : true;
      this.recorrencia = val.recorrencia;
      this.dateRange.startDate = this.item.dataInicio;
      this.dateRange.endDate = this.item.dataFim;
    },
    dateRange: function(val) {
      this.item.dataInicio = val.startDate;
      this.item.dataFim = val.endDate;
    },
    recorrencia: function(val) {
      this.item.recorrencia = val;
      this.hasRecorrencia = val == "" ? false : true;
      if (val == "DIA") {
        this.item.segunda = true;
        this.item.terca = true;
        this.item.quarta = true;
        this.item.quinta = true;
        this.item.sexta = true;
      } else if (val == "") {
        this.item.segunda = false;
        this.item.terca = false;
        this.item.quarta = false;
        this.item.quinta = false;
        this.item.sexta = false;
        this.item.sabado = false;
        this.item.domingo = false;
      }
    }
  },
  created() {
    if (this.agendaId) {
      this.get(this.agendaId);
    } else if (this.select) {
      this.item = {};
      this.item.dataInicio = this.select.data;
      this.item.dataFim = this.select.data;
      this.item.horaInicio = this.select.horaInicio;
      this.item.horaFim = this.select.horaFim;
      this.item.recorrencia = "";
      this.recorrencia = "";
      this.hasRecorrencia = false;
    } else {
      this.item = {};
      this.item.recorrencia = "";
      this.recorrencia = "";
      this.hasRecorrencia = false;
    }

    this.getConsultorList();
    this.getProjetoList();
    this.getexpedienteLocalList();
  },
  methods: {
    back() {
      this.item = {};
      this.closeModalAgendaRegra();
    },
    getexpedienteLocalList() {
      api
        .get(`crud/ExpedienteLocal`)
        .then(response => (this.expedienteLocalList = response.data["data"]));
    },
    getConsultorList() {
      api
        .get(`crud/Expediente/Consultores`)
        .then(response => (this.consultorList = response.data["data"]));
    },
    getProjetoList() {
      api
        .get(`api/Atendimento/Projetos`, {})
        .then(response => (this.projetoList = response.data["data"]));
    },
    removeAgendaRegraExcecao(id) {
      var conf = confirm(`Deseja remover a exceção`);
      if (conf) {
        api
          .post(`crud/AgendaRegra/DeleteAgendaRegraExcecao`, { id: id })
          .then(response => {
            if (response.data["status"].toLowerCase() == "success") {
              this.get(this.agendaId);
            } else {
              throw response;
            }
          });
      }
    },
    changeDiaSemana() {
      if (this.recorrencia == "DIA") {
        this.recorrencia = "SEM";
      }
    },
    closeAlert() {
      this.$store.dispatch("alert/clear");
    }
  }
};
</script>

<template>
  <div>
    <b-alert
      variant="danger"
      dismissible
      :show="alert.show"
      @dismissed="closeAlert"
    >
      {{ alert.message }}
    </b-alert>
    <b-form class="p-2" ref="form" @submit.prevent="save">
      <b-form-row>
        <b-form-group
          id="input-group-1"
          label="Consultor"
          label-for="consultorId"
          class="col-md-6"
        >
          <b-form-select id="consultorId" v-model="item.consultorId" required>
            <b-form-select-option disabled :value="undefined"
              >Selecione um item da lista</b-form-select-option
            >
            <b-form-select-option
              v-for="option in consultorList"
              :key="option.id"
              :value="option.id"
            >
              {{ option.nome }}
            </b-form-select-option>
          </b-form-select>
        </b-form-group>

        <b-form-group
          id="input-group-1"
          label="Local do expediente"
          label-for="tipoExpedienteId"
          class="col-md-6"
        >
          <b-form-select
            id="ExpedienteLocalId"
            v-model="item.expedienteLocalId"
            required
          >
            <b-form-select-option disabled :value="undefined"
              >Selecione um item da lista</b-form-select-option
            >
            <b-form-select-option
              v-for="option in expedienteLocalList"
              :key="option.id"
              :value="option.id"
            >
              {{ option.denominacao }}
            </b-form-select-option>
          </b-form-select>
        </b-form-group>
      </b-form-row>

      <b-form-group id="input-group-2" label="Projeto" label-for="ProjetoId">
        <b-form-select id="projetoId" v-model="item.projetoId" required>
          <b-form-select-option disabled :value="undefined"
            >Selecione um item da lista</b-form-select-option
          >
          <b-form-select-option
            v-for="option in ProjetosFormatados"
            :key="option.id"
            :value="option.id"
          >
            {{ option.descricaoSelect }}
          </b-form-select-option>
        </b-form-select>
      </b-form-group>

      <b-form-row>
        <b-form-group
          id="input-group-1"
          label="Horário de início"
          label-for="horaInicio"
          class="col-md-3"
        >
          <b-form-input
            id="horaInicio"
            v-model="item.horaInicio"
            type="text"
            v-mask="'##:##'"
            placeholder="00:00"
            required
          />
        </b-form-group>

        <b-form-group
          id="input-group-1"
          label="Horário de Fim"
          label-for="horaFim"
          class="col-md-3"
        >
          <b-form-input
            id="horaFim"
            v-model="item.horaFim"
            type="text"
            v-mask="'##:##'"
            placeholder="00:00"
            required
          />
        </b-form-group>

        <b-col>
          <b-form-group
            id="input-group-2"
            label="Recorrência"
            label-for="recorrencia"
          >
            <b-form-select id="recorrencia" v-model="recorrencia">
              <b-form-select-option value=""
                >Sem recorrência</b-form-select-option
              >
              <b-form-select-option value="DIA">Diária</b-form-select-option>
              <b-form-select-option value="SEM">Semanal</b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-row>
        <b-col>
          <b-form-group
            id="input-group-2"
            label="Período"
            label-for="dataRangeDataInicioDataFIm"
            v-if="hasRecorrencia"
          >
            <date-range-picker
              ref="picker"
              :opens="'right'"
              :locale-data="localeData"
              :ranges="customRanges()"
              :showWeekNumbers="true"
              :autoApply="true"
              v-model="dateRange"
              :linkedCalendars="true"
            >
              <template v-slot:input="picker" style="width: 365px !important;">
                {{ picker.startDate | formatField("date") }} -
                {{ picker.endDate | formatField("date") }}
              </template>
            </date-range-picker>
          </b-form-group>

          <b-form-group id="input-group-10" label="Data" v-if="!hasRecorrencia">
            <b-form-datepicker
              id="data"
              v-model="item.dataInicio"
              required
              placeholder="Selecione uma data"
              :hide-header="true"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-col>
            <b-form-group
              id="input-group-6"
              label="Dias da semana"
              class="font-bold"
              :disabled="!this.hasRecorrencia"
            >
              <b-row>
                <b-form-checkbox
                  v-model="item.segunda"
                  class="mr-1"
                  @change="changeDiaSemana"
                  >Segunda</b-form-checkbox
                >
                <b-form-checkbox
                  v-model="item.terca"
                  class="mr-1"
                  @change="changeDiaSemana"
                  >Terça</b-form-checkbox
                >
                <b-form-checkbox
                  v-model="item.quarta"
                  class="mr-1"
                  @change="changeDiaSemana"
                  >Quarta</b-form-checkbox
                >
                <b-form-checkbox
                  v-model="item.quinta"
                  class="mr-1"
                  @change="changeDiaSemana"
                  >Quinta</b-form-checkbox
                >
                <b-form-checkbox
                  v-model="item.sexta"
                  class="mr-1"
                  @change="changeDiaSemana"
                  >Sexta</b-form-checkbox
                >
              </b-row>
              <b-row class="mt-2">
                <b-form-checkbox
                  v-model="item.sabado"
                  class="mr-2"
                  @change="changeDiaSemana"
                  >Sábado</b-form-checkbox
                >
                <b-form-checkbox
                  v-model="item.domingo"
                  @change="changeDiaSemana"
                  >Domingo</b-form-checkbox
                >
              </b-row>
            </b-form-group>
          </b-col>
        </b-col>
      </b-form-row>

      <b-form-group
        id="input-group-12"
        label="Exceções"
        label-for="Exceções"
        class="col-md-6"
        v-if="hasRecorrencia && hasExcecoes"
      >
        <b-list-group>
          <div
            id="scrollspy-nested"
            style="position:relative; height:150px; overflow-y:auto"
          >
            <b-list-group-item
              class="d-flex justify-content-between align-items-center"
              v-for="excecao in item.agendaRegraExcecao"
              :key="excecao.id"
              :value="excecao.id"
            >
              {{ excecao.data | formatField("date") }}
              <b-button
                type="button"
                size="sm"
                variant="link"
                :key="excecao.id"
                @click="() => removeAgendaRegraExcecao(excecao.id)"
              >
                <i class="fe-trash-2" />
              </b-button>
            </b-list-group-item>
          </div>
        </b-list-group>
      </b-form-group>

      <b-form-group id="button-group" class="mt-4">
        <b-button variant="light" class="btn" v-on:click="back()"
          >Cancelar</b-button
        >
        <b-button type="submit" variant="primary" class="btn ml-2"
          >Salvar</b-button
        >
      </b-form-group>
    </b-form>
  </div>
</template>
